import AuthRoleWrapper from "../AuthRoleWrapper";
import RafflePage from "@/pages/Raffle/RafflePage";
import { siteRoutes } from "../siteRoutesList";
import TCLRafflePage from "@/pages/Raffle/TCLRafflePage";

export const raffleRoutes = [
  {
    element: () => AuthRoleWrapper({ Component: RafflePage }),
    path: siteRoutes["raffle"], // route to news overview
  },
  {
    element: () => AuthRoleWrapper({ Component: TCLRafflePage }),
    path: siteRoutes["TCLRaffle"], // route to news overview
  },
];
